const STORAGE_KEY = "other-store-recent-orders";
// Тот же префикс использует inline-скрипт в public/index.html.
const ORDER_TOKEN_KEY_PREFIX = "ts_order_token:";

function readAll() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore quota errors */
  }
}

export function saveRecentStoreOrder(storeId, orderId, accessToken) {
  if (!storeId || !orderId) {
    return;
  }
  const all = readAll();
  all[storeId] = {
    orderId,
    accessToken: accessToken || null,
    savedAt: Date.now(),
  };
  writeAll(all);
}

export function forgetRecentStoreOrder(storeId, orderId) {
  const all = readAll();
  if (!all[storeId] || (orderId && all[storeId].orderId !== orderId)) {
    return;
  }
  delete all[storeId];
  writeAll(all);
}

/** Убирает заказ из адреса страницы, не перерисовывая её: ссылка из истории браузера его больше не откроет. */
export function dropOrderFromUrl(orderId) {
  try {
    const url = new URL(window.location.href);
    if (!orderId || url.searchParams.get("order") !== orderId) {
      return;
    }
    url.searchParams.delete("order");
    url.searchParams.delete("token");
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
  } catch {
    /* ignore */
  }
}

export function getRecentStoreOrder(storeId) {
  if (!storeId) {
    return null;
  }
  return readAll()[storeId] ?? null;
}

/** Заказы «других магазинов», оформленные в этой вкладке, — новые первыми. */
export function getRecentStoreOrders() {
  return Object.entries(readAll())
    .filter(([, entry]) => entry?.orderId)
    .map(([storeId, entry]) => ({ storeId, ...entry }))
    .sort((a, b) => (b.savedAt || 0) - (a.savedAt || 0));
}

export function getRecentStoreOrderId(storeId) {
  return getRecentStoreOrder(storeId)?.orderId ?? null;
}

export function getRecentStoreOrderToken(storeId) {
  return getRecentStoreOrder(storeId)?.accessToken ?? null;
}

export function rememberOrderToken(orderId, accessToken) {
  if (!orderId || !accessToken) {
    return;
  }
  try {
    sessionStorage.setItem(`${ORDER_TOKEN_KEY_PREFIX}${orderId}`, accessToken);
  } catch {
    /* ignore quota errors */
  }
}

export function getRememberedOrderToken(orderId) {
  if (!orderId) {
    return null;
  }
  try {
    return sessionStorage.getItem(`${ORDER_TOKEN_KEY_PREFIX}${orderId}`);
  } catch {
    return null;
  }
}
